export const defaultEmailTemplate: string = `
<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <title>Subject here!</title>
</head>
<body style="font-family: Arial, sans-serif; font-size: 16px; color: #333; margin: 0; padding: 0; background-color: #f9f9f9;">
  <div style="max-width: 600px; margin: 20px auto; padding: 20px; border: 1px solid #ddd; border-radius: 8px; background-color: #fff; text-align: center;">
    <p style="margin: 0;">Your content here!</p>
  </div>
</body>
</html>
`